import Grid from '@mui/material/Grid';
import "./style.css";
import React from 'react';
import {useState, useEffect} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import NewCompanyPopUp from '../NewCompanyPopUp';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography'

  const RedButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: "#ff0000",
    '&:hover': {
      backgroundColor: "#8b0000",
    },
  }));

  export default function ChangeCompany({handleCompany, setCompanies, companies, handleCloseNoTelp, setcompanyID, setcompanyIDtoSave , closechangePerusahaanPopUPOpen, setContractData, contractData}){

    
    const [skip, setSkip] = useState(0)
    const [isEnd,setIsEnd] = useState("loading..")
    const [posts, setPosts] = useState([])
    const [query, setQuery] = useState('');
    const [batas,setBatas] = useState("No");

   
    
    useEffect(() => {
        fetchPosts();
    }, [skip,query]);
  

    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }
     

    const fetchPosts = async () => {
        console.log("feeeetchiiing")
      if(query.trim()){
              try{
                  const { data, error } = await read(skip,query,batas);
                  if(error){
                      console.log(error.message);
                      return;
                  }
      
                  if(data?.length === 0){
                      setIsEnd("Selesai...");
                      return;
                  }
                  
                  //success
                  setPosts([...posts, ...data])
              }catch(error){
                  console.log(error.message);
              }
          
      }else{
  
      try{
          const { data, error } = await readEmpty(skip,query,batas);
          if(error){
              console.log(error.message);
              return;
          }
  
          if(data?.length === 0){
              setIsEnd("Selesai...");
              return;
          }
          
          //success
          setPosts([...posts, ...data])
      }catch(error){
          console.log(error.message);
      } 
      }
  }  

  const newFetchPosts = async (event) => {
    setPosts([])
    setIsEnd("Loading...");
    if(event.target.value.trim()){
    try{
        const { data, error } = await read(skip,event.target.value);
        if(error){
            console.log(error.message);
            return;
        }
  
        if(data?.length === 0){
            setIsEnd("Selesai...");
            return;
        }
        
        //success
        setPosts([...data])
    }catch(error){
        console.log(error.message);
    }
    }else{
        console.log("empty")
        try{
            const { data, error } = await readEmpty(skip,event.target.value);
            if(error){
                console.log(error.message);
                return;
            }
  
            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
    }
  }

    const selectedCompany = (event) => {
        console.log(event.target.value)
    }
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;
    
        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
      }
      const [openNewCompany, setOpenNewCompany] = useState(false);

      const newCompany = () => {
        console.log("here")
        setOpenNewCompany(true);
    };
  
    const handleCloseNewCompany = () =>{
        setOpenNewCompany(false);
    }
    
    const selectNamaPerusahaan = (post) => {
        closechangePerusahaanPopUPOpen()
        setContractData({...contractData, CompanyName: post.namaPerusahaan, CompanyID: post._id});
        handleCloseNoTelp()

    }
    return <Grid container>
    <Dialog open={openNewCompany} onClose={handleCloseNewCompany}>
                <NewCompanyPopUp closechangePerusahaanPopUPOpen={closechangePerusahaanPopUPOpen} setContractData={setContractData} contractData={contractData} setcompanyIDtoSave={setcompanyIDtoSave} handleCloseNewCompany={handleCloseNewCompany} companies={companies} setCompanies={setCompanies} selectNamaPerusahaan={selectNamaPerusahaan} handleCompany2={handleCompany} setcompanyID={setcompanyID} handleCloseNoTelp={handleCloseNoTelp}></NewCompanyPopUp>
    </Dialog>
    <Grid container align = "center" justify = "center" alignItems = "center" sx={{pt:5, px:2, pb:2}}>
    <Typography sx={{mt:1, mb:3}}>Dibawah adalah daftar semua perusahaan yang pernah tersimpan di Zanio. Untuk perusahaan baru tekan "New+"</Typography>

                          <Grid sx={{mb:2}}>
                                <Button onClick={newCompany}>New +</Button>
                                <TextField
                                    value={query}
                                    onChange={handleSearch}
                                    placeholder="Search..."
                                />
                          </Grid>
                          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                              <TableContainer sx={{ maxHeight: 400, minHeight: 350 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                  <Table stickyHeader aria-label="sticky table">
                                      <TableHead>
                                          <TableRow>
                                              <TableCell>
                                                  Nama Company
                                              </TableCell>
                                              
                                          </TableRow>
                                      </TableHead>
                                      {posts?.map((post) => (
                                          <TableBody>
                                              <TableRow key={`${post.id}`}
                                                    hover
                                                    onClick={() => selectNamaPerusahaan(post)}>
                                                  <TableCell style={{cursor:'pointer'}}>
                                                      <p>{post.namaPerusahaan}</p>
                                                  </TableCell>
                                              </TableRow>
                                          </TableBody>
                                      
                                      ))}
                                      {isEnd}
                                  </Table>
                              </TableContainer>
                          </Paper>
                              
                          </Grid>
  </Grid>};